export default __webpack_public_path__ + "static/media/learning.637dd876.png";